export function doubleToHighLow(value) {
  return value != null ? (value < 0.5 ? 'Low' : 'High') : 'n/a';
}
